var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDaxtra = function SvgDaxtra(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.15 16.396-.05-.021-.025-.049c-.401-.805-.697-1.757-.878-2.83a21.491 21.491 0 0 1-.286-3.574c0-2.56.343-4.592 1.019-6.038l.022-.048.049-.022c1.19-.545 2.605-.821 4.203-.821 1.447 0 2.77.25 3.93.745l.056.024.022.055c.409 1.01.668 2.255.772 3.7l.01.133h3.1l-.026-.165c-.13-.844-.53-1.618-1.192-2.302-.63-.652-1.441-1.195-2.409-1.616l-.053-.023-.022-.052c-.796-1.838-2.155-2.77-4.038-2.77-2.09 0-3.638.961-4.598 2.855l-.022.043-.044.022a6.557 6.557 0 0 0-2.678 2.381C.341 7.078 0 8.39 0 9.922c0 1.728.345 3.16 1.024 4.256.664 1.07 1.611 1.877 2.816 2.4l.047.02.024.046c.951 1.816 2.438 2.737 4.418 2.737 1.855 0 3.24-.881 4.117-2.619l.025-.05.052-.02c1.922-.747 3.193-2.064 3.778-3.915l.06-.188h-3.24l-.012.132c-.134 1.469-.412 2.714-.826 3.7l-.026.061-.064.02c-1.209.388-2.56.584-4.014.584-1.547 0-2.903-.232-4.029-.69Z"
  })));
};

export default SvgDaxtra;